import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  kanbanData: false,
  openAccReceive: false,
  expensePerLineGraph: false,
  expensePerBarGraph: false,
  expenseBarChart: false,
  salesLineChart: false,
  expenseLineChart: false,
  profitLineChart: false,
  taskAtRisk: false,
  taskCompletionStatus: false,
  taskDeviationAnalysis: false,
  currentTotalBar: false,
  currentTotalLine: false,
  currentActualVsBudgetBar: false,
  currentActualVsBudgetLine: false,
  balanceDashboard: false,
  transactionDashboard: false,
  taxPieGraph: false,
  taxLineGraph: false,

  kanbanData2: false,
  openAccReceive2: false,
  expensePerLineGraph2: false,
  expensePerBarGraph2: false,
  expenseBarChart2: false,
  salesLineChart2: false,
  expenseLineChart2: false,
  profitLineChart2: false,
  taskAtRisk2: false,
  taskCompletionStatus2: false,
  taskDeviationAnalysis2: false,
  currentTotalBar2: false,
  currentTotalLine2: false,
  currentActualVsBudgetBar2: false,
  currentActualVsBudgetLine2: false,
  balanceDashboard2: false,
  transactionDashboard2: false,
  taxPieGraph2: false,
  taxLineGraph2: false,

  kanbanData3: false,
  openAccReceive3: false,
  expensePerLineGraph3: false,
  expensePerBarGraph3: false,
  expenseBarChart3: false,
  salesLineChart3: false,
  expenseLineChart3: false,
  profitLineChart3: false,
  taskAtRisk3: false,
  taskCompletionStatus3: false,
  taskDeviationAnalysis3: false,
  currentTotalBar3: false,
  currentTotalLine3: false,
  currentActualVsBudgetBar3: false,
  currentActualVsBudgetLine3: false,
  balanceDashboard3: false,
  transactionDashboard3: false,
  taxPieGraph3: false,
  taxLineGraph3: false,

  kanbanData4: false,
  openAccReceive4: false,
  expensePerLineGraph4: false,
  expensePerBarGraph4: false,
  expenseBarChart4: false,
  salesLineChart4: false,
  expenseLineChart4: false,
  profitLineChart4: false,
  taskAtRisk4: false,
  taskCompletionStatus4: false,
  taskDeviationAnalysis4: false,
  currentTotalBar4: false,
  currentTotalLine4: false,
  currentActualVsBudgetBar4: false,
  currentActualVsBudgetLine4: false,
  balanceDashboard4: false,
  transactionDashboard4: false,
  taxPieGraph4: false,
  taxLineGraph4: false,

  kanbanData5: false,
  openAccReceive5: false,
  expensePerLineGraph5: false,
  expensePerBarGraph5: false,
  expenseBarChart5: false,
  salesLineChart5: false,
  expenseLineChart5: false,
  profitLineChart5: false,
  taskAtRisk5: false,
  taskCompletionStatus5: false,
  taskDeviationAnalysis5: false,
  currentTotalBar5: false,
  currentTotalLine5: false,
  currentActualVsBudgetBar5: false,
  currentActualVsBudgetLine5: false,
  balanceDashboard5: false,
  transactionDashboard5: false,
  taxPieGraph5: false,
  taxLineGraph5: false,

  kanbanData6: false,
  openAccReceive6: false,
  expensePerLineGraph6: false,
  expensePerBarGraph6: false,
  expenseBarChart6: false,
  salesLineChart6: false,
  expenseLineChart6: false,
  profitLineChart6: false,
  taskAtRisk6: false,
  taskCompletionStatus6: false,
  taskDeviationAnalysis6: false,
  currentTotalBar6: false,
  currentTotalLine6: false,
  currentActualVsBudgetBar6: false,
  currentActualVsBudgetLine6: false,
  balanceDashboard6: false,
  transactionDashboard6: false,
  taxPieGraph6: false,
  taxLineGraph6: false,

  kanbanData7: false,
  openAccReceive7: false,
  expensePerLineGraph7: false,
  expensePerBarGraph7: false,
  expenseBarChart7: false,
  salesLineChart7: false,
  expenseLineChart7: false,
  profitLineChart7: false,
  taskAtRisk7: false,
  taskCompletionStatus7: false,
  taskDeviationAnalysis7: false,
  currentTotalBar7: false,
  currentTotalLine7: false,
  currentActualVsBudgetBar7: false,
  currentActualVsBudgetLine7: false,
  balanceDashboard7: false,
  transactionDashboard7: false,
  taxPieGraph7: false,
  taxLineGraph7: false,

  kanbanData8: false,
  openAccReceive8: false,
  expensePerLineGraph8: false,
  expensePerBarGraph8: false,
  expenseBarChart8: false,
  salesLineChart8: false,
  expenseLineChart8: false,
  profitLineChart8: false,
  taskAtRisk8: false,
  taskCompletionStatus8: false,
  taskDeviationAnalysis8: false,
  currentTotalBar8: false,
  currentTotalLine8: false,
  currentActualVsBudgetBar8: false,
  currentActualVsBudgetLine8: false,
  balanceDashboard8: false,
  transactionDashboard8: false,
  taxPieGraph8: false,
  taxLineGraph8: false,
};

const favDashboardSlice = createSlice({
  name: "Favourite/Dashboard/Fisibility",
  initialState,
  reducers: {
    toggle_Kanban_data: (state) => {
      state.kanbanData = !state.kanbanData;
    },
    reset_kanban_data: (state) => {
      state.kanbanData = false;
    },
    set_open_acc_receive: (state) => {
      state.openAccReceive = true;
      state.currentTotalLine = false;
    },
    reset_open_acc_receive: (state) => {
      state.openAccReceive = false;
    },
    set_expense_per_line_graph: (state) => {
      state.expensePerLineGraph = true;
    },
    set_expense_per_bar_graph: (state) => {
      state.expensePerBarGraph = true;
    },
    reset_expense_per_line_graph: (state) => {
      state.expensePerLineGraph = false;
    },
    reset_expense_per_bar_graph: (state) => {
      state.expensePerBarGraph = false;
    },
    set_expense_bar_chart: (state) => {
      state.expenseBarChart = true;
    },
    reset_expense_bar_chart: (state) => {
      state.expenseBarChart = false;
    },

    set_expense_line_chart: (state) => {
      state.expenseLineChart = true;
    },
    reset_expense_line_chart: (state) => {
      state.expenseLineChart = false;
    },

    set_profit_line_chart: (state) => {
      state.profitLineChart = true;
    },
    reset_profit_line_chart: (state) => {
      state.profitLineChart = false;
    },

    set_sales_line_chart: (state) => {
      state.salesLineChart = true;
    },
    reset_sales_line_chart: (state) => {
      state.salesLineChart = false;
    },
    set_task_complete_status: (state) => {
      state.taskCompletionStatus = true;
    },
    reset_task_complete_status: (state) => {
      state.taskCompletionStatus = false;
    },
    set_task_at_risk: (state) => {
      state.taskAtRisk = true;
    },
    reset_task_at_risk: (state) => {
      state.taskAtRisk = false;
    },
    set_task_deviation_analysis: (state) => {
      state.taskDeviationAnalysis = true;
    },
    reset_task_deviation_analysis: (state) => {
      state.taskDeviationAnalysis = false;
    },
    set_current_total_bar: (state) => {
      state.currentTotalBar = true;
    },
    reset_current_total_bar: (state) => {
      state.currentTotalBar = false;
    },
    set_current_total_line: (state) => {
      state.currentTotalLine = true;
    },
    reset_current_total_line: (state) => {
      state.currentTotalLine = false;
    },
    set_current_vs_actual_budget_bar: (state) => {
      state.currentActualVsBudgetBar = true;
    },
    reset_current_vs_actual_budget_bar: (state) => {
      state.currentActualVsBudgetBar = false;
    },
    set_current_vs_actual_budget_line: (state) => {
      state.currentActualVsBudgetLine = true;
    },
    reset_current_vs_actual_budget_line: (state) => {
      state.currentActualVsBudgetLine = false;
    },
    set_balance_dashboard: (state) => {
      state.balanceDashboard = true;
    },
    reset_balance_dashboard: (state) => {
      state.balanceDashboard = false;
    },
    set_transaction_dashboard: (state) => {
      state.transactionDashboard = true;
    },
    reset_transaction_dashboard: (state) => {
      state.transactionDashboard = false;
    },
    set_tax_line: (state) => {
      state.taxLineGraph = true;
    },
    reset_tax_line: (state) => {
      state.taxLineGraph = false;
    },
    set_tax_pie: (state) => {
      state.taxPieGraph = true;
    },
    reset_tax_pie: (state) => {
      state.taxPieGraph = false;
    },

    toggle_Kanban_data2: (state) => {
      state.kanbanData2 = !state.kanbanData2;
    },
    reset_kanban_data2: (state) => {
      state.kanbanData2 = false;
    },
    set_open_acc_receive2: (state) => {
      state.openAccReceive2 = true;
    },
    reset_open_acc_receive2: (state) => {
      // state.reset_open_acc_receive2 = false;
      state.openAccReceive2 = false;
    },
    set_expense_per_line_graph2: (state) => {
      state.expensePerLineGraph2 = true;
    },
    set_expense_per_bar_graph2: (state) => {
      state.expensePerBarGraph2 = true;
    },
    reset_expense_per_line_graph2: (state) => {
      state.expensePerLineGraph2 = false;
    },
    reset_expense_per_bar_graph2: (state) => {
      state.expensePerBarGraph2 = false;
    },
    set_expense_bar_chart2: (state) => {
      state.expenseBarChart2 = true;
    },
    reset_expense_bar_chart2: (state) => {
      state.expenseBarChart2 = false;
    },

    set_expense_line_chart2: (state) => {
      state.expenseLineChart2 = true;
    },
    reset_expense_line_chart2: (state) => {
      state.expenseLineChart2 = false;
    },

    set_profit_line_chart2: (state) => {
      state.profitLineChart2 = true;
    },
    reset_profit_line_chart2: (state) => {
      state.profitLineChart2 = false;
    },

    set_sales_line_chart2: (state) => {
      state.salesLineChart2 = true;
    },
    reset_sales_line_chart2: (state) => {
      state.salesLineChart2 = false;
    },
    set_task_complete_status2: (state) => {
      state.taskCompletionStatus2 = true;
    },
    reset_task_complete_status2: (state) => {
      state.taskCompletionStatus2 = false;
    },
    set_task_at_risk2: (state) => {
      state.taskAtRisk2 = true;
    },
    reset_task_at_risk2: (state) => {
      state.taskAtRisk2 = false;
    },
    set_task_deviation_analysis2: (state) => {
      state.taskDeviationAnalysis2 = true;
    },
    reset_task_deviation_analysis2: (state) => {
      state.taskDeviationAnalysis2 = false;
    },
    set_current_total_bar2: (state) => {
      state.currentTotalBar2 = true;
    },
    reset_current_total_bar2: (state) => {
      state.currentTotalBar2 = false;
    },
    set_current_total_line2: (state) => {
      state.currentTotalLine2 = true;
      state.openAccReceive2 = false;
    },
    reset_current_total_line2: (state) => {
      state.currentTotalLine2 = false;
    },
    set_current_vs_actual_budget_bar2: (state) => {
      state.currentActualVsBudgetBar2 = true;
    },
    reset_current_vs_actual_budget_bar2: (state) => {
      state.currentActualVsBudgetBar2 = false;
    },
    set_current_vs_actual_budget_line2: (state) => {
      state.currentActualVsBudgetLine2 = true;
    },
    reset_current_vs_actual_budget_line2: (state) => {
      state.currentActualVsBudgetLine2 = false;
    },
    set_balance_dashboard2: (state) => {
      state.balanceDashboard2 = true;
    },
    reset_balance_dashboard2: (state) => {
      state.balanceDashboard2 = false;
    },
    set_transaction_dashboard2: (state) => {
      state.transactionDashboard2 = true;
    },
    reset_transaction_dashboard2: (state) => {
      state.transactionDashboard2 = false;
    },
    set_tax_line2: (state) => {
      state.taxLineGraph2 = true;
    },
    reset_tax_line2: (state) => {
      state.taxLineGraph2 = false;
    },
    set_tax_pie2: (state) => {
      state.taxPieGraph2 = true;
    },
    reset_tax_pie2: (state) => {
      state.taxPieGraph2 = false;
    },

    toggle_Kanban_data3: (state) => {
      state.kanbanData3 = !state.kanbanData3;
    },
    reset_kanban_data3: (state) => {
      state.kanbanData3 = false;
    },
    set_open_acc_receive3: (state) => {
      state.openAccReceive3 = true;
    },
    reset_open_acc_receive3: (state) => {
      state.openAccReceive3 = false;
    },
    set_expense_per_line_graph3: (state) => {
      state.expensePerLineGraph3 = true;
    },
    set_expense_per_bar_graph3: (state) => {
      state.expensePerBarGraph3 = true;
    },
    reset_expense_per_line_graph3: (state) => {
      state.expensePerLineGraph3 = false;
    },
    reset_expense_per_bar_graph3: (state) => {
      state.expensePerBarGraph3 = false;
    },
    set_expense_bar_chart3: (state) => {
      state.expenseBarChart3 = true;
    },
    reset_expense_bar_chart3: (state) => {
      state.expenseBarChart3 = false;
    },

    set_expense_line_chart3: (state) => {
      state.expenseLineChart3 = true;
    },
    reset_expense_line_chart3: (state) => {
      state.expenseLineChart3 = false;
    },

    set_profit_line_chart3: (state) => {
      state.profitLineChart3 = true;
    },
    reset_profit_line_chart3: (state) => {
      state.profitLineChart3 = false;
    },

    set_sales_line_chart3: (state) => {
      state.salesLineChart3 = true;
    },
    reset_sales_line_chart3: (state) => {
      state.salesLineChart3 = false;
    },
    set_task_complete_status3: (state) => {
      state.taskCompletionStatus3 = true;
    },
    reset_task_complete_status3: (state) => {
      state.taskCompletionStatus3 = false;
    },
    set_task_at_risk3: (state) => {
      state.taskAtRisk3 = true;
    },
    reset_task_at_risk3: (state) => {
      state.taskAtRisk3 = false;
    },
    set_task_deviation_analysis3: (state) => {
      state.taskDeviationAnalysis3 = true;
    },
    reset_task_deviation_analysis3: (state) => {
      state.taskDeviationAnalysis3 = false;
    },
    set_current_total_bar3: (state) => {
      state.currentTotalBar3 = true;
    },
    reset_current_total_bar3: (state) => {
      state.currentTotalBar3 = false;
    },
    set_current_total_line3: (state) => {
      state.currentTotalLine3 = true;
    },
    reset_current_total_line3: (state) => {
      state.currentTotalLine3 = false;
    },
    set_current_vs_actual_budget_bar3: (state) => {
      state.currentActualVsBudgetBar3 = true;
    },
    reset_current_vs_actual_budget_bar3: (state) => {
      state.currentActualVsBudgetBar3 = false;
    },
    set_current_vs_actual_budget_line3: (state) => {
      state.currentActualVsBudgetLine3 = true;
    },
    reset_current_vs_actual_budget_line3: (state) => {
      state.currentActualVsBudgetLine3 = false;
    },
    set_balance_dashboard3: (state) => {
      state.balanceDashboard3 = true;
    },
    reset_balance_dashboard3: (state) => {
      state.balanceDashboard3 = false;
    },
    set_transaction_dashboard3: (state) => {
      state.transactionDashboard3 = true;
    },
    reset_transaction_dashboard3: (state) => {
      state.transactionDashboard3 = false;
    },
    set_tax_line3: (state) => {
      state.taxLineGraph3 = true;
    },
    reset_tax_line3: (state) => {
      state.taxLineGraph3 = false;
    },
    set_tax_pie3: (state) => {
      state.taxPieGraph3 = true;
    },
    reset_tax_pie3: (state) => {
      state.taxPieGraph3 = false;
    },

    toggle_Kanban_data4: (state) => {
      state.kanbanData4 = !state.kanbanData4;
    },
    reset_kanban_data4: (state) => {
      state.toggle_Kanban_data4 = false;
    },
    set_open_acc_receive4: (state) => {
      state.openAccReceive4 = true;
    },
    reset_open_acc_receive4: (state) => {
      state.openAccReceive4 = false;
    },
    set_expense_per_line_graph4: (state) => {
      state.expensePerLineGraph4 = true;
    },
    set_expense_per_bar_graph4: (state) => {
      state.expensePerBarGraph4 = true;
    },
    reset_expense_per_line_graph4: (state) => {
      state.expensePerLineGraph4 = false;
    },
    reset_expense_per_bar_graph4: (state) => {
      state.expensePerBarGraph4 = false;
    },
    set_expense_bar_chart4: (state) => {
      state.expenseBarChart4 = true;
    },
    reset_expense_bar_chart4: (state) => {
      state.expenseBarChart4 = false;
    },

    set_expense_line_chart4: (state) => {
      state.expenseLineChart4 = true;
    },
    reset_expense_line_chart4: (state) => {
      state.expenseLineChart4 = false;
    },

    set_profit_line_chart4: (state) => {
      state.profitLineChart4 = true;
    },
    reset_profit_line_chart4: (state) => {
      state.profitLineChart4 = false;
    },

    set_sales_line_chart4: (state) => {
      state.salesLineChart4 = true;
    },
    reset_sales_line_chart4: (state) => {
      state.salesLineChart4 = false;
    },
    set_task_complete_status4: (state) => {
      state.taskCompletionStatus4 = true;
    },
    reset_task_complete_status4: (state) => {
      state.taskCompletionStatus4 = false;
    },
    set_task_at_risk4: (state) => {
      state.taskAtRisk4 = true;
    },
    reset_task_at_risk4: (state) => {
      state.taskAtRisk4 = false;
    },
    set_task_deviation_analysis4: (state) => {
      state.taskDeviationAnalysis4 = true;
    },
    reset_task_deviation_analysis4: (state) => {
      state.taskDeviationAnalysis4 = false;
    },
    set_current_total_bar4: (state) => {
      state.currentTotalBar4 = true;
    },
    reset_current_total_bar4: (state) => {
      state.currentTotalBar4 = false;
    },
    set_current_total_line4: (state) => {
      state.currentTotalLine4 = true;
    },
    reset_current_total_line4: (state) => {
      state.currentTotalLine4 = false;
    },
    set_current_vs_actual_budget_bar4: (state) => {
      state.currentActualVsBudgetBar4 = true;
    },
    reset_current_vs_actual_budget_bar4: (state) => {
      state.currentActualVsBudgetBar4 = false;
    },
    set_current_vs_actual_budget_line4: (state) => {
      state.currentActualVsBudgetLine4 = true;
    },
    reset_current_vs_actual_budget_line4: (state) => {
      state.currentActualVsBudgetLine4 = false;
    },
    set_balance_dashboard4: (state) => {
      state.balanceDashboard4 = true;
    },
    reset_balance_dashboard4: (state) => {
      state.balanceDashboard4 = false;
    },
    set_transaction_dashboard4: (state) => {
      state.transactionDashboard4 = true;
    },
    reset_transaction_dashboard4: (state) => {
      state.transactionDashboard4 = false;
    },
    set_tax_line4: (state) => {
      state.taxLineGraph4 = true;
    },
    reset_tax_line4: (state) => {
      state.taxLineGraph4 = false;
    },
    set_tax_pie4: (state) => {
      state.taxPieGraph4 = true;
    },
    reset_tax_pie4: (state) => {
      state.taxPieGraph4 = false;
    },

    toggle_Kanban_data5: (state) => {
      state.kanbanData5 = !state.kanbanData5;
    },
    reset_kanban_data5: (state) => {
      state.kanbanData5 = false;
    },
    set_open_acc_receive5: (state) => {
      state.openAccReceive5 = true;
    },
    reset_open_acc_receive5: (state) => {
      state.openAccReceive5 = false;
    },
    set_expense_per_line_graph5: (state) => {
      state.expensePerLineGraph5 = true;
    },
    set_expense_per_bar_graph5: (state) => {
      state.expensePerBarGraph5 = true;
    },
    reset_expense_per_line_graph5: (state) => {
      state.expensePerLineGraph5 = false;
    },
    reset_expense_per_bar_graph5: (state) => {
      state.expensePerBarGraph5 = false;
    },
    set_expense_bar_chart5: (state) => {
      state.expenseBarChart5 = true;
    },
    reset_expense_bar_chart5: (state) => {
      state.expenseBarChart5 = false;
    },

    set_expense_line_chart5: (state) => {
      state.expenseLineChart5 = true;
    },
    reset_expense_line_chart5: (state) => {
      state.expenseLineChart5 = false;
    },

    set_profit_line_chart5: (state) => {
      state.profitLineChart5 = true;
    },
    reset_profit_line_chart5: (state) => {
      state.profitLineChart5 = false;
    },

    set_sales_line_chart5: (state) => {
      state.salesLineChart5 = true;
    },
    reset_sales_line_chart5: (state) => {
      state.salesLineChart5 = false;
    },
    set_task_complete_status5: (state) => {
      state.taskCompletionStatus5 = true;
    },
    reset_task_complete_status5: (state) => {
      state.taskCompletionStatus5 = false;
    },
    set_task_at_risk5: (state) => {
      state.taskAtRisk5 = true;
    },
    reset_task_at_risk5: (state) => {
      state.taskAtRisk5 = false;
    },
    set_task_deviation_analysis5: (state) => {
      state.taskDeviationAnalysis5 = true;
    },
    reset_task_deviation_analysis5: (state) => {
      state.taskDeviationAnalysis5 = false;
    },
    set_current_total_bar5: (state) => {
      state.currentTotalBar5 = true;
    },
    reset_current_total_bar5: (state) => {
      state.currentTotalBar5 = false;
    },
    set_current_total_line5: (state) => {
      state.currentTotalLine5 = true;
    },
    reset_current_total_line5: (state) => {
      state.currentTotalLine5 = false;
    },
    set_current_vs_actual_budget_bar5: (state) => {
      state.currentActualVsBudgetBar5 = true;
    },
    reset_current_vs_actual_budget_bar5: (state) => {
      state.currentActualVsBudgetBar5 = false;
    },
    set_current_vs_actual_budget_line5: (state) => {
      state.currentActualVsBudgetLine5 = true;
    },
    reset_current_vs_actual_budget_line5: (state) => {
      state.currentActualVsBudgetLine5 = false;
    },
    set_balance_dashboard5: (state) => {
      state.balanceDashboard5 = true;
    },
    reset_balance_dashboard5: (state) => {
      state.balanceDashboard5 = false;
    },
    set_transaction_dashboard5: (state) => {
      state.transactionDashboard5 = true;
    },
    reset_transaction_dashboard5: (state) => {
      state.transactionDashboard5 = false;
    },
    set_tax_line5: (state) => {
      state.taxLineGraph5 = true;
    },
    reset_tax_line5: (state) => {
      state.taxLineGraph5 = false;
    },
    set_tax_pie5: (state) => {
      state.taxPieGraph5 = true;
    },
    reset_tax_pie5: (state) => {
      state.taxPieGraph5 = false;
    },

    toggle_Kanban_data6: (state) => {
      state.kanbanData6 = !state.kanbanData6;
    },
    reset_kanban_data6: (state) => {
      state.kanbanData6 = false;
    },
    set_open_acc_receive6: (state) => {
      state.openAccReceive6 = true;
    },
    reset_open_acc_receive6: (state) => {
      state.openAccReceive6 = false;
    },
    set_expense_per_line_graph6: (state) => {
      state.expensePerLineGraph6 = true;
    },
    set_expense_per_bar_graph6: (state) => {
      state.expensePerBarGraph6 = true;
    },
    reset_expense_per_line_graph6: (state) => {
      state.expensePerLineGraph6 = false;
    },
    reset_expense_per_bar_graph6: (state) => {
      state.expensePerBarGraph6 = false;
    },
    set_expense_bar_chart6: (state) => {
      state.expenseBarChart6 = true;
    },
    reset_expense_bar_chart6: (state) => {
      state.expenseBarChart6 = false;
    },

    set_expense_line_chart6: (state) => {
      state.expenseLineChart6 = true;
    },
    reset_expense_line_chart6: (state) => {
      state.expenseLineChart6 = false;
    },

    set_profit_line_chart6: (state) => {
      state.profitLineChart6 = true;
    },
    reset_profit_line_chart6: (state) => {
      state.profitLineChart6 = false;
    },

    set_sales_line_chart6: (state) => {
      state.salesLineChart6 = true;
    },
    reset_sales_line_chart6: (state) => {
      state.salesLineChart6 = false;
    },
    set_task_complete_status6: (state) => {
      state.taskCompletionStatus6 = true;
    },
    reset_task_complete_status6: (state) => {
      state.taskCompletionStatus6 = false;
    },
    set_task_at_risk6: (state) => {
      state.taskAtRisk6 = true;
    },
    reset_task_at_risk6: (state) => {
      state.taskAtRisk6 = false;
    },
    set_task_deviation_analysis6: (state) => {
      state.taskDeviationAnalysis6 = true;
    },
    reset_task_deviation_analysis6: (state) => {
      state.taskDeviationAnalysis6 = false;
    },
    set_current_total_bar6: (state) => {
      state.currentTotalBar6 = true;
    },
    reset_current_total_bar6: (state) => {
      state.currentTotalBar6 = false;
    },
    set_current_total_line6: (state) => {
      state.currentTotalLine6 = true;
    },
    reset_current_total_line6: (state) => {
      state.currentTotalLine6 = false;
    },
    set_current_vs_actual_budget_bar6: (state) => {
      state.currentActualVsBudgetBar6 = true;
    },
    reset_current_vs_actual_budget_bar6: (state) => {
      state.currentActualVsBudgetBar6 = false;
    },
    set_current_vs_actual_budget_line6: (state) => {
      state.currentActualVsBudgetLine6 = true;
    },
    reset_current_vs_actual_budget_line6: (state) => {
      state.currentActualVsBudgetLine6 = false;
    },
    set_balance_dashboard6: (state) => {
      state.balanceDashboard6 = true;
    },
    reset_balance_dashboard6: (state) => {
      state.balanceDashboard6 = false;
    },
    set_transaction_dashboard6: (state) => {
      state.transactionDashboard6 = true;
    },
    reset_transaction_dashboard6: (state) => {
      state.transactionDashboard6 = false;
    },
    set_tax_line6: (state) => {
      state.taxLineGraph6 = true;
    },
    reset_tax_line6: (state) => {
      state.taxLineGraph6 = false;
    },
    set_tax_pie6: (state) => {
      state.taxPieGraph6 = true;
    },
    reset_tax_pie6: (state) => {
      state.taxPieGraph6 = false;
    },

    toggle_Kanban_data7: (state) => {
      state.kanbanData7 = !state.kanbanData7;
    },
    reset_kanban_data7: (state) => {
      state.kanbanData7 = false;
    },
    set_open_acc_receive7: (state) => {
      state.openAccReceive7 = true;
    },
    reset_open_acc_receive7: (state) => {
      state.openAccReceive7 = false;
    },
    set_expense_per_line_graph7: (state) => {
      state.expensePerLineGraph7 = true;
    },
    set_expense_per_bar_graph7: (state) => {
      state.expensePerBarGraph7 = true;
    },
    reset_expense_per_line_graph7: (state) => {
      state.expensePerLineGraph7 = false;
    },
    reset_expense_per_bar_graph7: (state) => {
      state.expensePerBarGraph7 = false;
    },
    set_expense_bar_chart7: (state) => {
      state.expenseBarChart7 = true;
    },
    reset_expense_bar_chart7: (state) => {
      state.expenseBarChart7 = false;
    },

    set_expense_line_chart7: (state) => {
      state.expenseLineChart7 = true;
    },
    reset_expense_line_chart7: (state) => {
      state.expenseLineChart7 = false;
    },

    set_profit_line_chart7: (state) => {
      state.profitLineChart7 = true;
    },
    reset_profit_line_chart7: (state) => {
      state.profitLineChart7 = false;
    },

    set_sales_line_chart7: (state) => {
      state.salesLineChart7 = true;
    },
    reset_sales_line_chart7: (state) => {
      state.salesLineChart7 = false;
    },
    set_task_complete_status7: (state) => {
      state.taskCompletionStatus2 = true;
    },
    reset_task_complete_status7: (state) => {
      state.taskCompletionStatus7 = false;
    },
    set_task_at_risk7: (state) => {
      state.taskAtRisk7 = true;
    },
    reset_task_at_risk7: (state) => {
      state.taskAtRisk7 = false;
    },
    set_task_deviation_analysis7: (state) => {
      state.taskDeviationAnalysis7 = true;
    },
    reset_task_deviation_analysis7: (state) => {
      state.taskDeviationAnalysis7 = false;
    },
    set_current_total_bar7: (state) => {
      state.currentTotalBar7 = true;
    },
    reset_current_total_bar7: (state) => {
      state.currentTotalBar7 = false;
    },
    set_current_total_line7: (state) => {
      state.currentTotalLine7 = true;
    },
    reset_current_total_line7: (state) => {
      state.currentTotalLine7 = false;
    },
    set_current_vs_actual_budget_bar7: (state) => {
      state.currentActualVsBudgetBar7 = true;
    },
    reset_current_vs_actual_budget_bar7: (state) => {
      state.currentActualVsBudgetBar7 = false;
    },
    set_current_vs_actual_budget_line7: (state) => {
      state.currentActualVsBudgetLine7 = true;
    },
    reset_current_vs_actual_budget_line7: (state) => {
      state.currentActualVsBudgetLine7 = false;
    },
    set_balance_dashboard7: (state) => {
      state.balanceDashboard7 = true;
    },
    reset_balance_dashboard7: (state) => {
      state.balanceDashboard7 = false;
    },
    set_transaction_dashboard7: (state) => {
      state.transactionDashboard7 = true;
    },
    reset_transaction_dashboard7: (state) => {
      state.transactionDashboard7 = false;
    },
    set_tax_line7: (state) => {
      state.taxLineGraph7 = true;
    },
    reset_tax_line7: (state) => {
      state.taxLineGraph7 = false;
    },
    set_tax_pie7: (state) => {
      state.taxPieGraph7 = true;
    },
    reset_tax_pie7: (state) => {
      state.taxPieGraph7 = false;
    },

    toggle_Kanban_data8: (state) => {
      state.kanbanData8 = !state.kanbanData8;
    },
    reset_kanban_data8: (state) => {
      state.kanbanData8 = false;
    },
    set_open_acc_receive8: (state) => {
      state.openAccReceive8 = true;
    },
    reset_open_acc_receive8: (state) => {
      state.openAccReceive8 = false;
    },
    set_expense_per_line_graph8: (state) => {
      state.expensePerLineGraph8 = true;
      // state.openAccReceive = false;
    },
    set_expense_per_bar_graph8: (state) => {
      state.expensePerBarGraph8 = true;
    },
    reset_expense_per_line_graph8: (state) => {
      state.expensePerLineGraph8 = false;
    },
    reset_expense_per_bar_graph8: (state) => {
      state.expensePerBarGraph8 = false;
    },
    set_expense_bar_chart8: (state) => {
      state.expenseBarChart8 = true;
    },
    reset_expense_bar_chart8: (state) => {
      state.expenseBarChart8 = false;
    },
    set_expense_line_chart8: (state) => {
      state.expenseLineChart8 = true;
    },
    reset_expense_line_chart8: (state) => {
      state.expenseLineChart8 = false;
    },
    set_profit_line_chart8: (state) => {
      state.profitLineChart8 = true;
    },
    reset_profit_line_chart8: (state) => {
      state.profitLineChart8 = false;
    },
    set_sales_line_chart8: (state) => {
      state.salesLineChart8 = true;
    },
    reset_sales_line_chart8: (state) => {
      state.salesLineChart8 = false;
    },
    set_task_complete_status8: (state) => {
      state.taskCompletionStatus8 = true;
    },
    reset_task_complete_status8: (state) => {
      state.taskCompletionStatus8 = false;
    },
    set_task_at_risk8: (state) => {
      state.taskAtRisk8 = true;
    },
    reset_task_at_risk8: (state) => {
      state.taskAtRisk8 = false;
    },
    set_task_deviation_analysis8: (state) => {
      state.taskDeviationAnalysis8 = true;
    },
    reset_task_deviation_analysis8: (state) => {
      state.taskDeviationAnalysis8 = false;
    },
    set_current_total_bar8: (state) => {
      state.currentTotalBar8 = true;
    },
    reset_current_total_bar8: (state) => {
      state.currentTotalBar8 = false;
    },
    set_current_total_line8: (state) => {
      state.currentTotalLine8 = true;
    },
    reset_current_total_line8: (state) => {
      state.currentTotalLine8 = false;
    },
    set_current_vs_actual_budget_bar8: (state) => {
      state.currentActualVsBudgetBar8 = true;
    },
    reset_current_vs_actual_budget_bar8: (state) => {
      state.currentActualVsBudgetBar8 = false;
    },
    set_current_vs_actual_budget_line8: (state) => {
      state.currentActualVsBudgetLine8 = true;
    },
    reset_current_vs_actual_budget_line8: (state) => {
      state.currentActualVsBudgetLine8 = false;
    },
    set_balance_dashboard8: (state) => {
      state.balanceDashboard8 = true;
    },
    reset_balance_dashboard8: (state) => {
      state.balanceDashboard8 = false;
    },
    set_transaction_dashboard8: (state) => {
      state.transactionDashboard8 = true;
    },
    reset_transaction_dashboard8: (state) => {
      state.transactionDashboard8 = false;
    },
    set_tax_line8: (state) => {
      state.taxLineGraph8 = true;
    },
    reset_tax_line8: (state) => {
      state.taxLineGraph8 = false;
    },
    set_tax_pie8: (state) => {
      state.taxPieGraph8 = true;
    },
    reset_tax_pie8: (state) => {
      state.taxPieGraph8 = false;
    },
  },
});

export const {
  toggle_Kanban_data,
  reset_kanban_data,
  set_open_acc_receive,
  reset_open_acc_receive,
  set_expense_per_bar_graph,
  set_expense_per_line_graph,
  reset_expense_per_bar_graph,
  reset_expense_per_line_graph,
  set_expense_bar_chart,
  reset_expense_bar_chart,
  set_expense_line_chart,
  reset_expense_line_chart,
  set_profit_line_chart,
  reset_profit_line_chart,
  set_sales_line_chart,
  reset_sales_line_chart,
  set_task_complete_status,
  reset_task_complete_status,
  set_task_at_risk,
  reset_task_at_risk,
  set_task_deviation_analysis,
  reset_task_deviation_analysis,
  set_current_total_bar,
  reset_current_total_bar,
  set_current_total_line,
  reset_current_total_line,
  set_current_vs_actual_budget_bar,
  reset_current_vs_actual_budget_bar,
  set_current_vs_actual_budget_line,
  reset_current_vs_actual_budget_line,
  set_balance_dashboard,
  reset_balance_dashboard,
  set_transaction_dashboard,
  reset_transaction_dashboard,
  set_tax_line,
  reset_tax_line,
  set_tax_pie,
  reset_tax_pie,

  toggle_Kanban_data2,
  reset_kanban_data2,
  set_open_acc_receive2,
  reset_open_acc_receive2,
  set_expense_per_bar_graph2,
  set_expense_per_line_graph2,
  reset_expense_per_bar_graph2,
  reset_expense_per_line_graph2,
  set_expense_bar_chart2,
  reset_expense_bar_chart2,
  set_expense_line_chart2,
  reset_expense_line_chart2,
  set_profit_line_chart2,
  reset_profit_line_chart2,
  set_sales_line_chart2,
  reset_sales_line_chart2,
  set_task_complete_status2,
  reset_task_complete_status2,
  set_task_at_risk2,
  reset_task_at_risk2,
  set_task_deviation_analysis2,
  reset_task_deviation_analysis2,
  set_current_total_bar2,
  reset_current_total_bar2,
  set_current_total_line2,
  reset_current_total_line2,
  set_current_vs_actual_budget_bar2,
  reset_current_vs_actual_budget_bar2,
  set_current_vs_actual_budget_line2,
  reset_current_vs_actual_budget_line2,
  set_balance_dashboard2,
  reset_balance_dashboard2,
  set_transaction_dashboard2,
  reset_transaction_dashboard2,
  set_tax_line2,
  reset_tax_line2,
  set_tax_pie2,
  reset_tax_pie2,

  toggle_Kanban_data3,
  reset_kanban_data3,
  set_open_acc_receive3,
  reset_open_acc_receive3,
  set_expense_per_bar_graph3,
  set_expense_per_line_graph3,
  reset_expense_per_bar_graph3,
  reset_expense_per_line_graph3,
  set_expense_bar_chart3,
  reset_expense_bar_chart3,
  set_expense_line_chart3,
  reset_expense_line_chart3,
  set_profit_line_chart3,
  reset_profit_line_chart3,
  set_sales_line_chart3,
  reset_sales_line_chart3,
  set_task_complete_status3,
  reset_task_complete_status3,
  set_task_at_risk3,
  reset_task_at_risk3,
  set_task_deviation_analysis3,
  reset_task_deviation_analysis3,
  set_current_total_bar3,
  reset_current_total_bar3,
  set_current_total_line3,
  reset_current_total_line3,
  set_current_vs_actual_budget_bar3,
  reset_current_vs_actual_budget_bar3,
  set_current_vs_actual_budget_line3,
  reset_current_vs_actual_budget_line3,
  set_balance_dashboard3,
  reset_balance_dashboard3,
  set_transaction_dashboard3,
  reset_transaction_dashboard3,
  set_tax_line3,
  reset_tax_line3,
  set_tax_pie3,
  reset_tax_pie3,

  toggle_Kanban_data4,
  reset_kanban_data4,
  set_open_acc_receive4,
  reset_open_acc_receive4,
  set_expense_per_bar_graph4,
  set_expense_per_line_graph4,
  reset_expense_per_bar_graph4,
  reset_expense_per_line_graph4,
  set_expense_bar_chart4,
  reset_expense_bar_chart4,
  set_expense_line_chart4,
  reset_expense_line_chart4,
  set_profit_line_chart4,
  reset_profit_line_chart4,
  set_sales_line_chart4,
  reset_sales_line_chart4,
  set_task_complete_status4,
  reset_task_complete_status4,
  set_task_at_risk4,
  reset_task_at_risk4,
  set_task_deviation_analysis4,
  reset_task_deviation_analysis4,
  set_current_total_bar4,
  reset_current_total_bar4,
  set_current_total_line4,
  reset_current_total_line4,
  set_current_vs_actual_budget_bar4,
  reset_current_vs_actual_budget_bar4,
  set_current_vs_actual_budget_line4,
  reset_current_vs_actual_budget_line4,
  set_balance_dashboard4,
  reset_balance_dashboard4,
  set_transaction_dashboard4,
  reset_transaction_dashboard4,
  set_tax_line4,
  reset_tax_line4,
  set_tax_pie4,
  reset_tax_pie4,

  toggle_Kanban_data5,
  reset_kanban_data5,
  set_open_acc_receive5,
  reset_open_acc_receive5,
  set_expense_per_bar_graph5,
  set_expense_per_line_graph5,
  reset_expense_per_bar_graph5,
  reset_expense_per_line_graph5,
  set_expense_bar_chart5,
  reset_expense_bar_chart5,
  set_expense_line_chart5,
  reset_expense_line_chart5,
  set_profit_line_chart5,
  reset_profit_line_chart5,
  set_sales_line_chart5,
  reset_sales_line_chart5,
  set_task_complete_status5,
  reset_task_complete_status5,
  set_task_at_risk5,
  reset_task_at_risk5,
  set_task_deviation_analysis5,
  reset_task_deviation_analysis5,
  set_current_total_bar5,
  reset_current_total_bar5,
  set_current_total_line5,
  reset_current_total_line5,
  set_current_vs_actual_budget_bar5,
  reset_current_vs_actual_budget_bar5,
  set_current_vs_actual_budget_line5,
  reset_current_vs_actual_budget_line5,
  set_balance_dashboard5,
  reset_balance_dashboard5,
  set_transaction_dashboard5,
  reset_transaction_dashboard5,
  set_tax_line5,
  reset_tax_line5,
  set_tax_pie5,
  reset_tax_pie5,

  toggle_Kanban_data6,
  reset_kanban_data6,
  set_open_acc_receive6,
  reset_open_acc_receive6,
  set_expense_per_bar_graph6,
  set_expense_per_line_graph6,
  reset_expense_per_bar_graph6,
  reset_expense_per_line_graph6,
  set_expense_bar_chart6,
  reset_expense_bar_chart6,
  set_expense_line_chart6,
  reset_expense_line_chart6,
  set_profit_line_chart6,
  reset_profit_line_chart6,
  set_sales_line_chart6,
  reset_sales_line_chart6,
  set_task_complete_status6,
  reset_task_complete_status6,
  set_task_at_risk6,
  reset_task_at_risk6,
  set_task_deviation_analysis6,
  reset_task_deviation_analysis6,
  set_current_total_bar6,
  reset_current_total_bar6,
  set_current_total_line6,
  reset_current_total_line6,
  set_current_vs_actual_budget_bar6,
  reset_current_vs_actual_budget_bar6,
  set_current_vs_actual_budget_line6,
  reset_current_vs_actual_budget_line6,
  set_balance_dashboard6,
  reset_balance_dashboard6,
  set_transaction_dashboard6,
  reset_transaction_dashboard6,
  set_tax_line6,
  reset_tax_line6,
  set_tax_pie6,
  reset_tax_pie6,

  toggle_Kanban_data7,
  reset_kanban_data7,
  set_open_acc_receive7,
  reset_open_acc_receive7,
  set_expense_per_bar_graph7,
  set_expense_per_line_graph7,
  reset_expense_per_bar_graph7,
  reset_expense_per_line_graph7,
  set_expense_bar_chart7,
  reset_expense_bar_chart7,
  set_expense_line_chart7,
  reset_expense_line_chart7,
  set_profit_line_chart7,
  reset_profit_line_chart7,
  set_sales_line_chart7,
  reset_sales_line_chart7,
  set_task_complete_status7,
  reset_task_complete_status7,
  set_task_at_risk7,
  reset_task_at_risk7,
  set_task_deviation_analysis7,
  reset_task_deviation_analysis7,
  set_current_total_bar7,
  reset_current_total_bar7,
  set_current_total_line7,
  reset_current_total_line7,
  set_current_vs_actual_budget_bar7,
  reset_current_vs_actual_budget_bar7,
  set_current_vs_actual_budget_line7,
  reset_current_vs_actual_budget_line7,
  set_balance_dashboard7,
  reset_balance_dashboard7,
  set_transaction_dashboard7,
  reset_transaction_dashboard7,
  set_tax_line7,
  reset_tax_line7,
  set_tax_pie7,
  reset_tax_pie7,

  toggle_Kanban_data8,
  reset_kanban_data8,
  set_open_acc_receive8,
  reset_open_acc_receive8,
  set_expense_per_bar_graph8,
  set_expense_per_line_graph8,
  reset_expense_per_bar_graph8,
  reset_expense_per_line_graph8,
  set_expense_bar_chart8,
  reset_expense_bar_chart8,
  set_expense_line_chart8,
  reset_expense_line_chart8,
  set_profit_line_chart8,
  reset_profit_line_chart8,
  set_sales_line_chart8,
  reset_sales_line_chart8,
  set_task_complete_status8,
  reset_task_complete_status8,
  set_task_at_risk8,
  reset_task_at_risk8,
  set_task_deviation_analysis8,
  reset_task_deviation_analysis8,
  set_current_total_bar8,
  reset_current_total_bar8,
  set_current_total_line8,
  reset_current_total_line8,
  set_current_vs_actual_budget_bar8,
  reset_current_vs_actual_budget_bar8,
  set_current_vs_actual_budget_line8,
  reset_current_vs_actual_budget_line8,
  set_balance_dashboard8,
  reset_balance_dashboard8,
  set_transaction_dashboard8,
  reset_transaction_dashboard8,
  set_tax_line8,
  reset_tax_line8,
  set_tax_pie8,
  reset_tax_pie8,
} = favDashboardSlice.actions;

export default favDashboardSlice;
